<script setup lang="ts">
const { coords } = defineProps<{
  coords: {
    lat: number
    lng: number
  }
}>()

const link = ref(`https://maps.google.com/maps?daddr=${coords.lat},${coords.lng}`)

onMounted(() => {
  if (
    (navigator.platform.indexOf('iPhone') != -1)
    || (navigator.platform.indexOf('iPod') != -1)
    || (navigator.platform.indexOf('iPad') != -1)
  ) {
    link.value = `maps://maps.apple.com?daddr=${coords.lat},${coords.lng}&ll=`
  }
})
</script>

<template>
  <a
    :href="link"
    target="_blank"
    rel="noopener noreferrer"
  >
    <slot />
    <!-- <pre>link: {{ link  }}</pre> -->
  </a>
</template>
